import React, { Component } from "react";
import PlatformSidebar from "./PlatformSidebar";
import "./Videos.css";
import VideosHome from "./VideosHome";
import Onboarding from "./Onboarding.js";
import AddFunds from "./AddFunds.js";
import ImportFromPassword from "./ImportFromPassword";
import SubscribeModal from "./SubscribeModal.js";
import TransactionStatus from "./TransactionStatus";
import HyperaceConnectWalletModal from "./HyperaceConnectWalletModal";
import { createAlchemyWeb3 } from "@alch/alchemy-web3";
import {
  bondingCurveContractAddress,
  bondingCurveOrchestratorContractAddress,
  mainnetBondingCurveContractAddress,
  mainnetBondingCurveOrchestratorContractAddress
} from "./config";
import * as encryptUtils from "./encryptDecryptUtils";
import * as loggingUtils from "./utils/loggingUtils";
import * as scriptUtils from "./utils/scriptUtils";
import axios from "axios";
const contract = require("./artifacts/contracts/BondingCurveNFT.sol/BondingCurveNFT.json");
const contract2 = require("./artifacts/contracts/BondingCurveOrchestrator.sol/BondingCurveOrchestrator.json");

let web3;
let usedContractAddress;
let usedContractV2Address;
if (process.env.REACT_APP_IS_MAINNET !== "testnet") {
  web3 = createAlchemyWeb3(process.env.REACT_APP_ETHEREUM_WEBSOCKET_URL);
  usedContractAddress = mainnetBondingCurveContractAddress;
  usedContractV2Address = mainnetBondingCurveOrchestratorContractAddress;
} else {
  web3 = createAlchemyWeb3(process.env.REACT_APP_GOERLI_WEBSOCKET_URL);
  usedContractAddress = bondingCurveContractAddress;
  usedContractV2Address = bondingCurveOrchestratorContractAddress;
}

class Videos extends Component {
  constructor(props) {
    super(props);
    this.selectModal = this.selectModal.bind(this);
    this.changeSearchText = this.changeSearchText.bind(this);
    this.setTransactionStatus = this.setTransactionStatus.bind(this);
    this.selectItemForSubscribe = this.selectItemForSubscribe.bind(this);
    this.markAsSubscribed = this.markAsSubscribed.bind(this);
    this.onUserClickedConnectWallet = this.onUserClickedConnectWallet.bind(this);

    this.state = {
      isLoaded: false,
      mintedVideos: [],
      searchText: "",
      selectedVideos: [],
      modalShown: "",
      transactionStatus: "None",
      transactedVideo: null,
      selectedItemForSubscribe: null,
      subscriberStatuses: {},
    };
  }

  setTransactionStatus(status) {
    this.setState({
      transactionStatus: status,
    });
  }

  markAsSubscribed(creator, subscriber) {
    creator = creator.toLowerCase();
    subscriber = subscriber.toLowerCase();
    let creatorMapping;
    let subscriberStatusesCopy = {...this.state.subscriberStatuses};
    if(!(creator in subscriberStatusesCopy)) {
      creatorMapping = {};
      creatorMapping[subscriber] = true;
    } else {
      creatorMapping = subscriberStatusesCopy[creator];
      creatorMapping[subscriber] = true;
    }
    subscriberStatusesCopy[creator] = creatorMapping;
    this.setState({
      subscriberStatuses: subscriberStatusesCopy,
    });
  }

  async componentDidMount() {
    let mintedVideos = await encryptUtils.getMintReadyNFTs(["0", "1", "2"]);
    mintedVideos = mintedVideos.sort((a, b) => {
      if (a.protocol !== "the402" && b.protocol === "the402") {
        return 1;
      } else if (a.protocol === "the402" && b.protocol !== "the402") {
        return -1;
      } else if (a.protocol === "the402" && b.protocol === "the402") {
        return parseInt(b.tokenId) - parseInt(a.tokenId);
      } else {
        return parseFloat(b.moneyInContract) - parseFloat(a.moneyInContract);
      }
    });
    for (let i = 0; i < mintedVideos.length; i++) {
      let video = mintedVideos[i];
      let rawAddress = video["creatorAddress"];
      if (rawAddress != null) {
        rawAddress =
          rawAddress.substring(0, 5) +
          "..." +
          rawAddress.substring(rawAddress.length - 5);
        video["displayedCreatorAddress"] = rawAddress;
        video["creatorProfileImage"] = scriptUtils.getProfileImage(
          video["creatorAddress"]
        );
      }
      mintedVideos[i] = video;
    }
    this.setState({
      mintedVideos,
      selectedVideos: mintedVideos,
      isLoaded: true,
    });
    let subscriberStatuses = await encryptUtils.getSubscriberStatuses();
    this.setState({
      subscriberStatuses,
    });
    let self = this;
    const bondingCurveContract = new web3.eth.Contract(
      contract.abi,
      usedContractAddress
    );
    const bondingCurveV2Contract = new web3.eth.Contract(
      contract2.abi,
      usedContractV2Address
    );
    bondingCurveContract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        let items = self.state.mintedVideos;
        for (let i = 0; i < items.length; i++) {
          let item = items[i];
          if (data["authUUID"] !== item["authUUID"]) {
            continue;
          }
          let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
          let tokenId = item["tokenId"];
          let currentBuyPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply + 1,
            "liquid"
          );
          let currentSellPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply,
            "liquid"
          );
          let moneyInContract = await encryptUtils.computeMoneyInContract(
            tokenId,
            "liquid"
          );
          let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
          let currentSellFeePerThousand = item["currentSellFeePerThousand"];
          item["baseBuyPrice"] = currentBuyPrice;
          item["baseSellPrice"] = currentSellPrice;
          currentBuyPrice *= 1 + currentBuyFeePerThousand / 1000;
          currentSellPrice *= 1 - (currentSellFeePerThousand + 25) / 1000;
          item["mintPrice"] = currentBuyPrice;
          item["sellPrice"] = currentSellPrice;
          item["moneyInContract"] = moneyInContract;
          item["currentSupply"] = newSupply;
          items[i] = item;
          self.setState({
            mintedVideos: items,
            selectedVideos: items,
          });
          if (
            self.props.account == null ||
            data["to"].toLowerCase() !==
              self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Mint Complete",
            transactedVideo: item,
          });
        }
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveContract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        let items = self.state.mintedVideos;
        for (let i = 0; i < items.length; i++) {
          let item = items[i];
          if (data["authUUID"] !== item["authUUID"]) {
            continue;
          }
          let pastBondingCurveMintEvents = await bondingCurveContract.getPastEvents("ItemMinted", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let pastBondingCurveBurnEvents = await bondingCurveContract.getPastEvents("ItemBurned", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
          let tokenId = item["tokenId"];
          let currentBuyPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply + 1,
            "liquid"
          );
          let currentSellPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply,
            "liquid"
          );
          let moneyInContract = await encryptUtils.computeMoneyInContract(
            tokenId,
            "liquid"
          );
          let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
          let currentSellFeePerThousand = item["currentSellFeePerThousand"];
          item["baseBuyPrice"] = currentBuyPrice;
          item["baseSellPrice"] = currentSellPrice;
          currentBuyPrice *= 1 + currentBuyFeePerThousand / 1000;
          currentSellPrice *= 1 - (currentSellFeePerThousand + 25) / 1000;
          item["mintPrice"] = currentBuyPrice;
          item["sellPrice"] = currentSellPrice;
          item["moneyInContract"] = moneyInContract;
          item["currentSupply"] = newSupply;
          items[i] = item;
          self.setState({
            mintedVideos: items,
            selectedVideos: items,
          });
          if (
            self.props.account == null ||
            data["burner"].toLowerCase() !==
              self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Burn Complete",
            transactedVideo: item,
          });
        }
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemMinted()
      .on("data", async function (event) {
        let data = event.returnValues;
        let items = self.state.mintedVideos;
        for (let i = 0; i < items.length; i++) {
          let item = items[i];
          if (data["authUUID"] !== item["authUUID"]) {
            continue;
          }
          let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
          let tokenId = item["tokenId"];
          let currentBuyPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply + 1,
            "liquidv2"
          );
          let currentSellPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply,
            "liquidv2"
          );
          let moneyInContract = await encryptUtils.computeMoneyInContract(
            tokenId,
            "liquidv2"
          );
          let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
          let currentSellFeePerThousand = item["currentSellFeePerThousand"];
          item["baseBuyPrice"] = currentBuyPrice;
          item["baseSellPrice"] = currentSellPrice;
          currentBuyPrice *= 1 + currentBuyFeePerThousand / 1000;
          currentSellPrice *= 1 - (currentSellFeePerThousand + 25) / 1000;
          item["mintPrice"] = currentBuyPrice;
          item["sellPrice"] = currentSellPrice;
          item["moneyInContract"] = moneyInContract;
          item["currentSupply"] = newSupply;
          items[i] = item;
          self.setState({
            mintedVideos: items,
            selectedVideos: items,
          });
          if (
            self.props.account == null ||
            data["to"].toLowerCase() !==
              self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Mint Complete",
            transactedVideo: item,
          });
        }
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    bondingCurveV2Contract.events
      .ItemBurned()
      .on("data", async function (event) {
        let data = event.returnValues;
        let items = self.state.mintedVideos;
        for (let i = 0; i < items.length; i++) {
          let item = items[i];
          if (data["authUUID"] !== item["authUUID"]) {
            continue;
          }
          let pastBondingCurveMintEvents = await bondingCurveV2Contract.getPastEvents("ItemMinted", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let pastBondingCurveBurnEvents = await bondingCurveV2Contract.getPastEvents("ItemBurned", {
            fromBlock: 0,
            toBlock: 'latest'
          });
          let filteredPastBondingCurveMintEvents = pastBondingCurveMintEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let filteredPastBondingCurveBurnEvents = pastBondingCurveBurnEvents.filter(event => event.returnValues.authUUID === item.authUUID);
          let newSupply = filteredPastBondingCurveMintEvents.length - filteredPastBondingCurveBurnEvents.length;
          let tokenId = item["tokenId"];
          let currentBuyPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply + 1,
            "liquidv2"
          );
          let currentSellPrice = await encryptUtils.computeCurrentPrice(
            tokenId,
            newSupply,
            "liquidv2"
          );
          let moneyInContract = await encryptUtils.computeMoneyInContract(
            tokenId,
            "liquidv2"
          );
          let currentBuyFeePerThousand = item["currentBuyFeePerThousand"];
          let currentSellFeePerThousand = item["currentSellFeePerThousand"];
          item["baseBuyPrice"] = currentBuyPrice;
          item["baseSellPrice"] = currentSellPrice;
          currentBuyPrice *= 1 + currentBuyFeePerThousand / 1000;
          currentSellPrice *= 1 - (currentSellFeePerThousand + 25) / 1000;
          item["mintPrice"] = currentBuyPrice;
          item["sellPrice"] = currentSellPrice;
          item["moneyInContract"] = moneyInContract;
          item["currentSupply"] = newSupply;
          items[i] = item;
          self.setState({
            mintedVideos: items,
            selectedVideos: items,
          });
          if (
            self.props.account == null ||
            data["burner"].toLowerCase() !==
              self.props.account.address.toLowerCase()
          ) {
            return;
          }
          self.setState({
            transactionStatus: "Burn Complete",
            transactedVideo: item,
          });
        }
      })
      .on("error", function (event) {
        self.setState({
          transactionStatus: "Failed",
        });
      });
    mintedVideos = await encryptUtils.getLeaderboardDataBulk(
      mintedVideos,
      this.props.account != null ? this.props.account.address : null,
      "uri"
    );
    this.setState({
      mintedVideos,
      selectedVideos: mintedVideos,
    });
    for (let i = 0; i < mintedVideos.length; i++) {
      let video = mintedVideos[i];
      video["displayedCreatorAddress"] = await encryptUtils.getENS(
        video["creatorAddress"]
      );
      mintedVideos[i] = video;
      this.setState({
        mintedVideos,
        selectedVideos: mintedVideos,
      });
    }
    loggingUtils.logEvent(
      this.props.account != null
        ? this.props.account.address
        : encryptUtils.getWalletUnconnectedUserId(),
      "videos",
      "videos_page_load",
      "info",
      "https://the402.xyz",
      {}
    );
  }

  async componentDidUpdate(prevProps) {
    if (this.props.account !== prevProps.account) {
      let address = null;
      if (this.props.account != null) {
        address = this.props.account.address;
      }
      let mintedVideos = this.state.mintedVideos;
      mintedVideos = await encryptUtils.getLeaderboardDataBulk(
        mintedVideos,
        address,
        "uri"
      );
      this.setState({
        mintedVideos,
        selectedVideos: mintedVideos,
        isLoaded: true,
      });
    }
  }

  changeSearchText(event) {
    this.setState({
      searchText: event.target.value,
      selectedVideos: this.state.mintedVideos.filter(
        (video) =>
          video.name.toLowerCase().includes(event.target.value.toLowerCase()) ||
          video.description
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
      ),
    });
  }

  selectModal(modal) {
    this.setState({
      modalShown: modal,
    });
  }

  onUserClickedConnectWallet() {
    loggingUtils.logEvent(
      encryptUtils.getWalletUnconnectedUserId(),
      "item_dedicated_page",
      "item_dedicated_page_like_item_with_wallet_disconnected",
      "info",
      "https://the402.xyz",
      {}
    );
    let buttons = document.getElementsByTagName("button");
    for (let i = 0; i < buttons.length; i++) {
      let button = buttons[i];
      if (button.outerText === "Connect Wallet") {
        button.click();
      }
    }
  }

  selectItemForSubscribe(item) {
    if(this.props.account != null) {
      this.setState({
        modalShown: "subscribe",
        selectedItemForSubscribe: item,
      });
    } else {
      this.onUserClickedConnectWallet();
    }
  }

  render() {
    return (
      <div>
        <div>
          <PlatformSidebar
            modalShown={this.state.modalShown}
            selectModal={this.selectModal}
          />
        </div>
        <div className="min-h-screen bg-custom-white dark:bg-custom-black">
          {
            <VideosHome
              onChangeSearchText={this.changeSearchText}
              selectedVideos={this.state.selectedVideos}
              allVideos={this.state.mintedVideos}
              searchText={this.state.searchText}
              address={
                this.props.account != null ? this.props.account.address : null
              }
              setTransactionStatus={this.setTransactionStatus}
              selectItemForSubscribe={this.selectItemForSubscribe}
              subscriberStatuses={this.state.subscriberStatuses}
            />
          }
        </div>
        {
          this.state.modalShown === "createAccount"
            ?
          <Onboarding selectModal={this.selectModal} />
            :
          this.state.modalShown === "addFunds"
            ?
          <AddFunds selectModal={this.selectModal} />
            :
          this.state.modalShown === "importFromPassword"
            ?
          <ImportFromPassword selectModal={this.selectModal} />
            :
          this.state.modalShown === "subscribe"
            ?
          <SubscribeModal
            selectModal={this.selectModal}
            account={this.props.account}
            item={this.state.selectedItemForSubscribe}
            markAsSubscribed={this.markAsSubscribed}
          />
            :
          null
        }
        <TransactionStatus
          transactionStatus={this.state.transactionStatus}
          item={this.state.transactedVideo}
        />
      </div>
    );
  }
}

export default Videos;
